module.exports = __webpack_public_path__ + "img/story_slide_3.6b75c034.jpg";